<template>
    <section>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

        <!--列表-->
        <el-table :data="RechargeConfig" v-loading="listLoading" style="width: 100%" ref="table" @select="dialogCheck"
            @row-click="selectCurrentRow" class="custom-tbl">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column type="index" width="80"> </el-table-column>
            <el-table-column prop="Title" label="标题" sortable>
            </el-table-column>
            <el-table-column prop="Label" label="标签" sortable>
            </el-table-column>
            <el-table-column prop="Description" label="描述" sortable>
            </el-table-column>
            <el-table-column prop="Amount" label="金额" sortable>
            </el-table-column>
            
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                style="float: right">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="标题" prop="Title">
                    <el-input v-model="editForm.Title" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="标签" prop="Label">
                    <el-input v-model="editForm.Label" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="Description">
                    <el-input v-model="editForm.Description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="Amount">
                    <el-input v-model="editForm.Amount" type="text" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入总金额" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="标题" prop="Title">
                    <el-input v-model="addForm.Title" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="标签" prop="Label">
                    <el-input v-model="addForm.Label" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="Description">
                    <el-input v-model="addForm.Description" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="Amount">
                    <el-input v-model="addForm.Amount" type="text" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入总金额" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>
  
<script>
import util from "../../../util/date";
import {
    getRechargeConfigPage,
    removeRechargeConfig,
    editRechargeConfig,
    addRechargeConfig,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
    components: { Toolbar },
    data() {
        return {
            buttonList: [],
            currentRow: null,
            filters: {
                LinkUrl: "",
            },
            RechargeConfig: [],
            total: 0,
            page: 1,
            listLoading: false,
            sels: [], //列表选中列

            addDialogFormVisible: false,
            editFormVisible: false, //编辑界面是否显示
            editLoading: false,
            //编辑界面数据
            editForm: {
                Id: 0,
                Title: '',
                Label: '',
                Amount: 0,
                Description: '',
            },
            editFormRules: {
                LinkUrl: [
                    { required: true, message: "编辑", trigger: "blur" },
                ],
            },

            addFormVisible: false, //新增界面是否显示
            addLoading: false,
            //新增界面数据
            addForm: {
                Title: '',
                Label: '',
                Amount: 0,
                Description: '',
            },
            addFormRules: {
                LinkUrl: [
                    { required: true, message: "新增", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        dialogCheck(selection, row) {
            this.currentRow = null;
            this.$refs.table.clearSelection();
            if (selection.length === 0) {
                return;
            }
            if (row) {
                this.selectCurrentRow(row);
            }
        },
        selectCurrentRow(val) {
            if (val) {
                this.currentRow = val;
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(val, true);
            }
        },
        callFunction(item) {
            this.filters = {
                name: item.search,
            };
            this[item.Func].apply(this, item);
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getRechargeConfigs();
        },
        //获取用户列表
        getRechargeConfigs() {
            let para = {
                page: this.page,
                key: this.filters.name,
            };
            this.listLoading = true;

            getRechargeConfigPage(para).then((res) => {
                this.total = res.data.response.dataCount;
                this.RechargeConfig = res.data.response.data;
                this.listLoading = false;
                //NProgress.done();
            });
        },
        //删除
        handleDel() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要删除的一行数据！",
                    type: "error",
                });

                return;
            }
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning",
            })
                .then(() => {
                    this.listLoading = true;
                    //NProgress.start();
                    let para = { id: row.Id };
                    removeRechargeConfig(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.listLoading = false;
                            return;
                        }
                        this.listLoading = false;
                        //NProgress.done();
                        if (res.data.success) {
                            this.currentRow=null;
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }

                        this.getRechargeConfigs();
                    });
                })
                .catch(() => { });
        },
        //显示编辑界面
        handleEdit() {
            let row = this.currentRow;
            if (!row) {
                this.$message({
                    message: "请选择要编辑的一行数据！",
                    type: "error",
                });

                return;
            }
            this.editFormVisible = true;
            this.editForm = Object.assign({}, row);
        },
        //显示新增界面
        handleAdd() {
            this.addFormVisible = true;
            this.addForm = {
                Title: '',
                Label: '',
                Amount: '',
                Description: '',
            };
        },
        //编辑
        editSubmit: function () {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    this.$confirm("确认提交吗？", "提示", {}).then(() => {
                        this.editLoading = true;
                        //NProgress.start();
                        let para = Object.assign({}, this.editForm);

                        editRechargeConfig(para).then((res) => {
                            if (util.isEmt.format(res)) {
                                this.editLoading = false;
                                return;
                            }
                            if (res.data.success) {
                                this.editLoading = false;
                                this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                });
                                this.$refs["editForm"].resetFields();
                                this.editFormVisible = false;
                                this.currentRow=null;
                                this.getRechargeConfigs();
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                        });
                    });
                }
            });
        },
        //新增
        addSubmit: function () {
            let _this = this;
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.addLoading = true;
                    let para = Object.assign({}, this.addForm);
                    console.log("123", this.addForm);
                    addRechargeConfig(para).then((res) => {
                        if (util.isEmt.format(res)) {
                            this.addLoading = false;
                            return;
                        }

                        if (res.data.success) {
                            this.addLoading = false;
                            //NProgress.done();
                            this.$message({
                                message: res.data.msg,
                                type: "success",
                            });
                            this.$refs["addForm"].resetFields();
                            this.addFormVisible = false;
                            this.currentRow=null;
                            this.getRechargeConfigs();
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error",
                            });
                        }
                    });
                }
            });
        },
    },
    mounted() {
        this.getRechargeConfigs();

        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>
  
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
}
</style>
  